/**
 * Multifactor Authentication Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const MultifactorAuthenticationSettingsState = {
  multifactorAuthenticationSettings: {},
  multifactorAuthenticationSettingsLoading: false,
}

export const MultifactorAuthenticationSettingsActions = {
  createMultifactorAuthenticationSettings: async ({ commit }, value) => {
    commit('setMultifactorAuthenticationSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'multifactor_authentication',
        value,
      }).
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMultifactorAuthenticationSettingsLoading', false))
  },

  getMultifactorAuthenticationSettings: async ({ commit }) => {
    commit('setMultifactorAuthenticationSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/multifactor_authentication').
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMultifactorAuthenticationSettingsLoading', false))
  },

  updateMultifactorAuthenticationSettings: async ({ getters, commit }, value) => {
    commit('setMultifactorAuthenticationSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.multifactorAuthenticationSettingsId}`, {
        name: 'multifactor_authentication',
        value,
      }).
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMultifactorAuthenticationSettingsLoading', false))
  },

  deleteMultifactorAuthenticationSettings: async ({ getters, commit }) => {
    commit('setMultifactorAuthenticationSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.multifactorAuthenticationSettingsId}`).
      then(({ data }) => {
        commit('setMultifactorAuthenticationSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMultifactorAuthenticationSettingsLoading', false))
  },
}

export const MultifactorAuthenticationSettingsMutations = {
  setMultifactorAuthenticationSettings: (state, payload) => {
    state.multifactorAuthenticationSettings = payload
  },
  setMultifactorAuthenticationSettingsLoading: (state, payload) => {
    state.multifactorAuthenticationSettingsLoading = payload
  },
  setMultifactorAuthenticationSettingsValue: (state, payload) => {
    state.multifactorAuthenticationSettings.value = payload
  },
}

export const MultifactorAuthenticationSettingsGetters = {
  multifactorAuthenticationSettings: state => state.multifactorAuthenticationSettings,
  multifactorAuthenticationSettingsId: state => state.multifactorAuthenticationSettings?.id,
  multifactorAuthenticationSettingsLoading: state => state.multifactorAuthenticationSettingsLoading,
  multifactorAuthenticationSettingsValue: state => state.multifactorAuthenticationSettings?.value,
}
